import React from 'react';
import PropTypes from 'prop-types';
import Accordion from '../Accordion/Accordion';
import AccordionItem from '../Accordion/AccordionItem';
import { useHistory } from 'react-router-dom';
import useMode from '../../hooks/useMode';
import Address from '../Address/Address';
import { EmailType, PhoneType, ProfileType } from '../Profile/types';
import { RpCheck2Type } from '@ecosconnect/core/src/types/jobFormData';

export type WaterSupplier = {
  profileId: string;
  acceptEmail: boolean;
  reportName: string;
  gracePeriod: string;
  rpCheck2Type: RpCheck2Type;
  profile: {
    id: string;
    name: string;
    type: ProfileType;
    contactAddress?: {
      id: string;
      street1: string;
      street2: string;
      city: string;
      state: string;
      zip: string;
      zipExt: string;
    };
    phones: {
      id: string;
      subType: PhoneType;
      value: string;
      extension: string;
    }[];
    emails: {
      id: string;
      subType: EmailType;
      value: string;
    }[];
  };
};

type WaterSupplierDetailProps = {
  waterSupplier: WaterSupplier;
};

const WaterSupplierDetail: React.FC<WaterSupplierDetailProps> = ({
  waterSupplier,
}) => {
  const history = useHistory();
  const mode = useMode();

  return (
    <>
      <Accordion title="Contact">
        <AccordionItem label="Name" value={waterSupplier.profile.name} />
        {waterSupplier.profile.phones.map((phone, idx) => (
          <AccordionItem
            key={`${phone.id}-${idx}`}
            label={
              phone.subType === 'UNKNOWN' ? `Phone` : `Phone (${phone.subType})`
            }
            value={phone.value}
          />
        ))}
        {waterSupplier.profile.emails.map((email, idx) => (
          <AccordionItem
            key={`${email.id}-${idx}`}
            label={
              email.subType === 'UNKNOWN' ? `Email` : `Email (${email.subType})`
            }
            value={email.value}
          />
        ))}
        {waterSupplier.profile.contactAddress && (
          <AccordionItem
            label="Mailing Address"
            value={<Address address={waterSupplier.profile.contactAddress} />}
          />
        )}
      </Accordion>
    </>
  );
};

WaterSupplierDetail.propTypes = {
  waterSupplier: PropTypes.any,
};

export default WaterSupplierDetail;
